module.exports = __webpack_public_path__ + "img/[菜刀].b892a922.svg";